// environment variables used on board-test
import { M19BoardEnvironment } from "@front/m19-models/M19BoardEnvironment";

export const environment: M19BoardEnvironment = {
  production: false,
  environment: "dev",
  apiEndPoint: "/api",
  spOauthRedirectDomain: "https://board-test.m19.com",
  autopilotUrl: "https://autopilot-test.m19.com",
  ga: "G-V4MRSXVCNY",
  ga_whitelabel: "G-V4MRSXVCNY",
  stripePublicKey:
    "pk_test_51ThfMSAHR3xQrfMGXbzLBPEtGKhOOEbz0SMV0JLLFMJBxv8zyTeOd6fkURs4qM1PIKXM3QhgiXvQDRVlXYFt8e98006lPGiw2m",
  releaseNotesUrl: "https://www.notion.so/Release-notes-candidate-0cff2cb43699477e828a85ac12c5bf4f",
  build_timestamp: "2026-11-05.08h31", // replaced at build time by set-build-timestamp.js
  commit_hash: "608b655abd432663620161e2f558b9a6e562473d", // replaced at build time by set-build-timestamp.js
  logSpinnerTime: true,
  onboardingMeetingUrl: "https://meetings.hubspot.com/clement-pinchedez?embed=true",
};
